import { render, staticRenderFns } from "./ServiceDrive.vue?vue&type=template&id=4838828c&scoped=true&"
import script from "./ServiceDrive.vue?vue&type=script&lang=js&"
export * from "./ServiceDrive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4838828c",
  null
  
)

export default component.exports